import React, { FC } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { Task } from '../../lib/interfaces/Task';
import TasksSidebarListItem from './TasksSidebarListItem';
import { Course } from '../../lib/interfaces/Course';
import './TasksSidebarList.scss';

type TasksSidebarProps = {
	course: Course;
	currentTask: string;
};

const TasksSidebarList: FC<TasksSidebarProps> = ({ course, currentTask }) => (
	<Box className="TasksSidebarList">
		<List sx={{ padding: '10px 10px 0 10px' }}>
			{course.tasks.map((task: Task) => (
				<TasksSidebarListItem
					key={task.id}
					task={task}
					courseSlug={course.slug}
					currentTask={currentTask}
				/>
			))}
		</List>
	</Box>
);

export default TasksSidebarList;
